/* eslint-disable camelcase */
import { createSelector } from 'reselect';

const selectCountries = createSelector(
  (state) => state.countries.payload,
  (payload) =>
    payload
      .map((item) => ({
        label: item.name,
        value: item.id,
      }))
      .sort((a, b) => {
        if (a.label.toLowerCase() < b.label.toLowerCase()) {
          return -1;
        }
        if (a.label.toLowerCase() > b.label.toLowerCase()) {
          return 1;
        }
        return 0;
      }),
);

const selectCountriesCode = createSelector(
  (state) => state.countries.payload,
  (payload) => {
    const resp = payload
      .map((item) => ({
        label: item.name,
        value: item.alpha2,
        countryEu: item.ue_country,
      }))
      .sort((a, b) => {
        if (a.label.toLowerCase() < b.label.toLowerCase()) {
          return -1;
        }
        if (a.label.toLowerCase() > b.label.toLowerCase()) {
          return 1;
        }
        return 0;
      })
      .reduce((acc, element) => {
        if (element.value === 'US') {
          return [element, ...acc];
        }
        return [...acc, element];
      }, [])
      .reduce((acc, element) => {
        if (element.value === 'IT') {
          return [element, ...acc];
        }
        return [...acc, element];
      }, []);

    return resp;
  }
);

const selectSubdivisions = createSelector(
  (state) => state.countries.subdivisions,
  ({ data }) => {
    if (!data) return [];

    return data.map(({ attributes }) => ({
      label: attributes.name,
      value: attributes.code,
    }));
    /* .sort((a, b) => {
        if (a.label.toLowerCase() < b.label.toLowerCase()) {
          return -1;
        }
        if (a.label.toLowerCase() > b.label.toLowerCase()) {
          return 1;
        }
        return 0;
      }) */
  },
);

const selectBirthSubdivisions = createSelector(
  (state) => state.countries.birthSubdivisions,
  ({ data }) => {
    if (!data) return [];

    return data.map(({ attributes }) => ({
      label: attributes.name,
      value: attributes.code,
    }));
  },
);

// Il `value` e' la DENOMINAZIONE, non il codice catastale: il backend risolve
// il codice confrontando `denomination` con quanto arriva in `birthCity`.
// Mandare il codice catastale farebbe fallire la ricerca in silenzio.
const selectMunicipalities = createSelector(
  (state) => state.countries.municipalities,
  ({ data }) => {
    if (!data) return [];

    return data.map(({ attributes }) => ({
      label: attributes.denomination,
      value: attributes.denomination,
      cadastrianCode: attributes.cadastrianCode,
    }));
  },
);

export default selectCountries;
export {
  selectCountriesCode,
  selectSubdivisions,
  selectBirthSubdivisions,
  selectMunicipalities,
};
